import React, { useState } from "react";

const PricingVehicleSpecsTabs = ({ promisesData = [], headerInfo = "Key Specifications" }) => {
  const [activeTab, setActiveTab] = useState(0);

  if (!promisesData || promisesData.length === 0) {
    return null;
  }

  return (
    <div className="w-full md:w-[84%] mx-auto px-3 md:px-0 py-8 md:py-12 bg-white">
      <div className="w-full">
        {/* Heading */}
        {headerInfo && (
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8">
            {headerInfo}
          </h2>
        )}
        
        {/* Component with border */}
        <div className="w-full border border-gray-200 rounded-lg overflow-hidden">
          {/* Tabs */}
          <div className="flex flex-nowrap gap-2 md:gap-3 border-b border-gray-200 bg-gray-50 px-4 md:px-6 overflow-x-auto overflow-y-hidden pb-0">
            {promisesData.map((item, index) => (
              <button
                key={item.id || index}
                onClick={() => setActiveTab(index)}
                className={`px-4 md:px-6 py-2.5 md:py-3 text-sm md:text-base font-medium transition-all duration-200 whitespace-nowrap relative ${
                  activeTab === index
                    ? "text-[#024670] font-semibold"
                    : "text-gray-600 hover:text-gray-900"
                }`}
                style={{
                  borderBottom: activeTab === index ? "2px solid #024670" : "2px solid transparent",
                  marginBottom: "-2px",
                }}
              >
                {item.question}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="w-full p-4 md:p-6">
            {promisesData[activeTab] && (
              <div className="w-full">
                {promisesData[activeTab].tableData && (
                  <div className="space-y-0">
                    {promisesData[activeTab].tableData.map((row, rowIndex) => (
                      <div
                        key={rowIndex}
                        className="flex items-center py-3 md:py-3.5 border-b border-gray-200 last:border-b-0"
                      >
                        <div className="text-sm md:text-base font-semibold text-gray-700 min-w-[180px] md:min-w-[220px]">
                          {row.feature}
                        </div>
                        <div className="text-sm md:text-base text-gray-900 font-normal">
                          {row.details}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingVehicleSpecsTabs;
